import { Checkbox, Divider, Grid, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import IconsColor from './iconsColor';
import globalStyles from "../../assets/styles/global.module.scss";
import styles from "../../assets/styles/componentStyles/accountInformationCard.module.scss";
import GlobalButton from './globalButton/button';
import metaIcon from "../../assets/images/chatbot/metaIcon.png";
import { agentActivityMessage, chatbotIntegrationAssignmentData, chatbotIntegrationAssignmentDataNew, checkCallEnableResponse, enableDisableAgentActivityMsgPayload, syncCatalogPayload, voiceAgentAssignmentInterface } from '../../models/axiosModel';
import GlobalPopUp from './globalPopUp';
import whatsappIcon from '../../assets/Whatsapp.svg'
import businessName from '../../assets/chatbotAssets/businessName.svg'
import QRimage from '../../assets/chatbotAssets/QRimage.png'
import { ChatbotContext, ChatbotContextPayload } from '../../context/chatbotContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import GlobalTooltip from './tooltip/globalTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getSelectedPhoneNumber } from '../dashboard/channels/global/whatsapp/whatsAppIntegrationConstant';
import { IntegrationContext, IntegrationContextPayload } from '../../context/integrationContext';
import { primaryColor, tertiaryColor, whiteColor } from '../../utils/colors';
import { hasChannelsManageAccess, isAdmin, isDev, phoneNumberQrText } from '../../utils/constants';
import { getDisplayWabaFieldKeyName } from '../../utils/constants';
import agent from '../../services/api';
import { UserContext, UserContextPayload } from '../../context/userContext';
import PrimaryIOSSwitch from './switch/primaryIOSSwitch';
import AgentActivityMessages from '../dashboard/channels/global/whatsapp/agentActivityMessages';
import AgentInactivityTime from '../dashboard/channels/global/whatsapp/agentInactivityTime';
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import { useGenericStore } from '../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import ConfigurationHeader from '../dashboard/chatbot/configurationPopup/ConfigurationHeader';
import ConfigurationSection from '../dashboard/chatbot/configurationPopup/ConfigurationSection';
import ConfigurationPopup from '../dashboard/chatbot/configurationPopup/ConfigurationPopup';
import CallIcon from '@mui/icons-material/Call';
import MessageIcon from '@mui/icons-material/Message';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import QrCodePopup from './qrCodePopup';

interface Details {
    phone_number_id?: string,
    integrated_channel_id?: string,
    // linked_chatbots?: chatbotIntegrationAssignmentData[],
    linked_chatbots?: (chatbotIntegrationAssignmentDataNew | chatbotIntegrationAssignmentData)[], 
    linked_workflows?: (chatbotIntegrationAssignmentDataNew | chatbotIntegrationAssignmentData)[], 
    display_phone_number?: string,
    waba_id?: string,
    verified_name?: string,
    quality_rating?: string,
    business_name?: string, 
    business_verification_status?: string,
    marketing_messages_lite_api_status?: string,
    currency?: string,
    marketing_messages_onboarding_status?: string,
    waba_account_status?: string,
    whatsapp_messaging_limit?: string,
    catalog?: string,
    meta_integration_whatsapp_phone_number_id?: number,
    flag_send_agent_activity_message?: boolean,
    agent_activity_message?: agentActivityMessage[],
    flag_disable_agent_on_user_inactivity?: boolean,
    time_of_inactivity_in_ms?: number,
    flag_smb_phone_number?: boolean,
    flag_agent_assignment_on_smb_message?: boolean,
}
interface AccountInformationCardProps {
    title: string,
    details: Details,
    currentlySelected: boolean,
    flagDelete: boolean,
    flagShowMetaIcon?: boolean,
    deleteChatbotIntegration?: () => void;
    removeChatbotIntegration?: (phone_number_id: string, integrated_channel_id?: string) => void
    addChatbotIntegration?: (phone_number_id: string, integrated_channel_id: string, event?: React.MouseEvent<HTMLButtonElement>) => void
    showRemoveChatbotIntegration?: boolean,
    flagIntegration?: boolean,
    flagShowLinkedChatbot?: boolean,
    flagShowCustomRecipient?: boolean,
    disabled?: boolean,
    flagShowPhoneNumberSettings?: boolean;
}
const getValueStyle = (keyName: string, value: string) => {
    switch (keyName.toLowerCase().replaceAll(" ", "_")) {
        case "quality_rating":
            return { color: value.toLowerCase() == "green" ? "#4AC958" : value.toLowerCase(), fontSize: "15px", fontWeight: "500" };
        default:
            return { fontSize: "14px", fontWeight: "400", color: "#000" }
    }
}


const getFontColor = (value: string) => {
    switch (value) {
        case "GREEN":
            return "#32BB46"
        case "RED":
            return "#BB3232"
        case "YELLOW":
            return "#D4B132"
        default:
            return "#000000"
    }
}

const getDisplayIcon = (keyName: string) => {
    switch (keyName.toLowerCase().replaceAll(" ", "_")) {
        case "waba_id":
            return <img alt="" src={whatsappIcon} height={"20"} width={"20"} style={{ display: "flex" }} />;
        case "verified_name":
            return <img alt="" src={businessName} height={"20"} width={"20"} />;

        case "currency": 
            return <IconsColor iconName="dollarIcon" height={"20"} width={"20"} />;
        case "marketing_messages_onboarding_status":
            return <IconsColor iconName="messageOnboardingStatus" height={"20"} width={"20"} />;
        case "business_verification_status":
            return <IconsColor iconName="VerifyIcon" height={"20"} width={"20"} />;
        case "marketing_messages_lite_api_status": 
            return <IconsColor iconName="apiStatusIcon" height={"20"} width={"20"} />;
        case "whatsapp_messaging_limit": 
            return <IconsColor iconName="messagesLimitIcon" height={"20"} width={"20"} />;
        case "waba_account_status": 
            return <IconsColor iconName="verifyAccountIcon" height={"20"} width={"20"} />;
        case "catalog":
            return <StoreMallDirectoryOutlinedIcon className={styles.catalogIcon} />;

        case "display_phone_number":
            return "Phone Number";
        case "quality_rating":
            return "Quality rating";
        case "phone_number_id":
            return "Phone Number ID";
        case "meta_business_id":
            return "Meta Business ID";
        case "linked_chatbots":
            return "Linked Chatbots"; 
        case "linked_workflows":
            return "Linked Workflows";
        default:
            return null
    }
}

export default function AccountInformationCard(props: AccountInformationCardProps) {
    
    const { title, details, currentlySelected, flagDelete, flagShowMetaIcon, showRemoveChatbotIntegration, flagShowPhoneNumberSettings = true } = props;
    const { chatbotList } = useContext(ChatbotContext) as ChatbotContextPayload
    const { integrationListNewStructure, setIntegrationDetails, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload
    const { setFlagLoading, handleError, userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [showQRCodePopUp, setShowQRCodePopUp] = useState<boolean>(false)
    const [phoneNumberQR, setPhoneNumberQR] = useState<string>("")
    const [callEnabledResponse, setCallEnabledResponse] = useState<checkCallEnableResponse | null>(null)
    const [assignedVoiceAgentData, setAssignedVoiceAgentData] = useState<voiceAgentAssignmentInterface | null>(null);

    const [flagSendAgentActicityMsg, setFlagSendAgentActicityMsg] = useState<boolean>(props?.details?.flag_send_agent_activity_message ?? false);
    const [agentAcitvityMsg, setAgentAcitvityMsg] = useState<agentActivityMessage[]>(props?.details?.agent_activity_message ?? []);

    const [flagDisableAgentOnUserInactivity, setFlagDisableAgentOnUserInactivity] = useState<boolean>(props?.details?.flag_disable_agent_on_user_inactivity ?? false);
    const [timeOfInactivityInMs, setTimeOfInactivityInMs] = useState<number>(props?.details?.time_of_inactivity_in_ms ?? 0);

    const [flagAgentAssignmentOnSmbMsg, setFlagAgentAssignmentOnSmbMsg] = useState<boolean>(props?.details?.flag_agent_assignment_on_smb_message ?? false);

    const [showPhoneNumberSettingsPopup, setShowPhoneNumberSettingsPopup] = useState<boolean>(false);

    const [searchParams] = useSearchParams();
    let id = searchParams.get('id')
    const navigate = useNavigate();

    const getTitleOfCustomRecipientTooltip = () => {
        const selectedPhoneNumber = getSelectedPhoneNumber(integrationListNewStructure, id, props.details.phone_number_id);
        if (selectedPhoneNumber) {
            if (selectedPhoneNumber.contact_chatbot_assignment_data?.length > 0) {
                return `${selectedPhoneNumber.contact_chatbot_assignment_data?.length} contacts have overridden the default chatbot.`;
            }
        }
        return "By default, all messages to this number are handled by the main chatbot. You can override this behavior for specific contacts by assigning a custom chatbot.";
    }

    const checkCallEnable = async () => {
        if (details?.phone_number_id) {
            let res = await agent.checkCallingEnabled.get(details?.phone_number_id)
            if (res?.status) {
                setCallEnabledResponse(res?.data)
            }
            else {
                handleError(res)
                setCallEnabledResponse(null)
            }
        }
    }

    const getAssignedVoiceAgents = async () => {
        if (details?.meta_integration_whatsapp_phone_number_id) {
            let res = await agent.getVoiceAgentAssignment.get(Number(details?.meta_integration_whatsapp_phone_number_id) || 0)
            if (!res?.status) {
                handleError(res)
            }
            else {
                setAssignedVoiceAgentData(res?.data)
            }
        }
    }


    const handleSetCallEnable = async (value: boolean) => {
        if (details?.phone_number_id) {
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: true }
            });
            let payload = {
                phone_number_id: details?.phone_number_id,
                enable_flag: value
            }
            let res = await agent.enableCallNumber.post(payload)
            if (res?.status) {
                showSuccess(value ? "Calling Enabled Successfully!" : "Calling Disabled Successfully!")
                await checkCallEnable()
            }
            else {
                handleError(res)
            }
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: false }
            });
        }
    }

    useEffect(() => {
        (async () => {
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: true }
            });
            if (details?.phone_number_id) {
                await checkCallEnable()
                await getAssignedVoiceAgents()
            }
            setFlagLoading((prevState) => {
                return { ...prevState, flagRoundLoader: false }
            });
        })()
    }, [details?.phone_number_id])

    const shouldShowVoiceCallingSwitch = () => {
        if((isAdmin(userDetail) || isDev(userDetail)) && details?.phone_number_id && !(props?.details?.flag_smb_phone_number)){
            return true;
        } 
        return false;
    }

    const shouldShowAssignedVoiceAgent = () => {
        return details?.phone_number_id && Boolean(callEnabledResponse?.calling_enabled);
    }
    
    const onChangeOfSendAgentActivityMsgSwitch = async (checked: boolean) => {
        setFlagSendAgentActicityMsg(checked)
        if(!checked) {
            if(props?.details?.agent_activity_message && props?.details?.agent_activity_message?.length > 0){
                const res = await configureAgentActivityMsg(checked, flagDisableAgentOnUserInactivity);
                if(res?.status){
                    showSuccess('Send agent activity message has been turned off')
                }
            }
        }
    }

    const onChangeOfRemoveAgentOnUserInactivitySwitch = async (checked: boolean) => {
        setFlagDisableAgentOnUserInactivity(checked);
        if(!checked) {
            if(props?.details?.time_of_inactivity_in_ms && props?.details?.time_of_inactivity_in_ms > 0) {
                const res = await configureAgentActivityMsg(flagSendAgentActicityMsg, checked);
                if(res?.status){
                    showSuccess('Remove agent on user inactivity has been turned off')
                }
            }
        }
    }

    const configureAgentActivityMsg = async (flagSendAgentActicityMsg: boolean, flagDisableAgentOnUserInactivity: boolean) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: enableDisableAgentActivityMsgPayload = {
            integrated_channel_id: props?.details?.integrated_channel_id ? Number(props?.details?.integrated_channel_id) : 0,
            flag_send_agent_activity_message: flagSendAgentActicityMsg,
            flag_disable_agent_on_user_inactivity: flagDisableAgentOnUserInactivity,
            time_of_inactivity_in_ms: flagDisableAgentOnUserInactivity ? timeOfInactivityInMs : null,
            agent_activity_message: flagSendAgentActicityMsg ? agentAcitvityMsg?.filter((msg) => msg?.message?.trim() !== '')?.map((msg) => {
                return {
                    agent_activity_message_type_id: msg?.agent_activity_message_type_id,
                    agent_activity_message_type_name: msg?.agent_activity_message_type_name,
                    message: msg.message,
                    agent_activity_message_variable: msg.agent_activity_message_variable?.map((variable) => {
                        return {
                            agent_activity_message_variable_type_id: variable?.agent_activity_message_variable_type_id ?? 0,
                            agent_activity_message_variable_type_name: variable?.agent_activity_message_variable_type_name,
                            metadata_type_id: variable?.metadata_type_id ?? null,
                            variable_key: variable?.variable_key,
                            fallback_value: variable?.fallback_value
                        }
                    })
                }
            }) : []
        }

        const res  = await agent.enableDisableAgentActivityMsg.post(payload)
        if(res?.status){
            setIntegrationDetails((prev) => {
                if(!prev) return prev;
                if(String(prev?.integrated_channel_id) === String(id)){
                    return {
                        ...prev,
                        meta_integration_phone_number_data: prev?.meta_integration_phone_number_data?.map((phoneNumber) => {
                            if(String(phoneNumber?.integrated_channel_id) == String(props?.details?.integrated_channel_id ?? '')){
                                return {
                                    ...phoneNumber,
                                    flag_send_agent_activity_message: payload?.flag_send_agent_activity_message,
                                    flag_disable_agent_on_user_inactivity: payload?.flag_disable_agent_on_user_inactivity,
                                    time_of_inactivity_in_ms: payload?.time_of_inactivity_in_ms ?? 0,
                                    agent_activity_message: payload?.agent_activity_message
                                }
                            }
                            return phoneNumber;
                        })
                    }
                }
                return prev;
            });
            setAgentAcitvityMsg(payload?.agent_activity_message);
            setTimeOfInactivityInMs(payload?.time_of_inactivity_in_ms ?? 0);
        }
        else {
            handleError(res)
        }

        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        return res;
    }

    const onCancelOfAgentActivityMsg = () => {
        setAgentAcitvityMsg(props?.details?.agent_activity_message ?? []);
        setShowPhoneNumberSettingsPopup(false);
    }

    const onCancelOfUserInactivity = () => {
        setTimeOfInactivityInMs(props?.details?.time_of_inactivity_in_ms ?? 0);
        setShowPhoneNumberSettingsPopup(false);
    }

    const onChangeOfAssignAgentOnSmbMsg = async (value: boolean) => {
        setFlagAgentAssignmentOnSmbMsg(value);
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            integrated_channel_id: Number(props?.details?.integrated_channel_id) ?? 0,
            flag_agent_assignment_on_smb_message_configuration: value
        }
        const res = await agent.toggleSmbAgentAssignment.post(payload);
        if(!(res?.status)){
            handleError(res);
        } else {
            showSuccess(value ? 'Assign agent on SMB message configured successfully' : 'Assign agent on SMB agent has been turned off')
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const syncCatalogApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload: syncCatalogPayload = {
            waba_id: props?.details?.waba_id ?? ''
        }
        const res = await agent.syncCatalog.post(payload);
        if(!(res?.status)){
            handleError(res);
        } else {
            await getMetaIntegrationList(true);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const renderTabInfo = (value: string) => {
        return (
            <Grid container className={`${globalStyles.displayFlex} ${globalStyles.fullwidth}`} gap={1} flexWrap={"nowrap"}>
                <Grid item className={styles.tabInfoValue} xs={12}>
                    {value}
                </Grid>
            </Grid>
        )
    }

    // Tabs Data
    const voiceCallingTabData = (
        <Grid container direction="column" gap={2}>
            {renderTabInfo("Enable or disable voice calling for customers on this WhatsApp number")}

            <ConfigurationSection>
                <Grid container className={styles.voiceCallingToggleRow}>
                    <Grid item className={styles.voiceCallingToggleLabel}>
                        Voice Calling
                    </Grid>

                    <Grid item className={globalStyles.displayFlex}>
                        <PrimaryIOSSwitch
                            className={styles.switch}
                            checked={Boolean(callEnabledResponse?.calling_enabled)}
                            onChange={(e) => { handleSetCallEnable(e.target.checked) }}
                            disabled={!hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail)}
                        />
                    </Grid>
                </Grid>
            </ConfigurationSection>

            {shouldShowAssignedVoiceAgent() &&
                <>
                    <Divider />
                    <ConfigurationSection
                        title="Assigned Voice Agent"
                        description="Voice agent currently assigned to handle calls on this phone number."
                    >
                        <Grid item className={styles.assignedVoiceAgentValue}>
                            {assignedVoiceAgentData?.is_assigned
                                ? <a rel="noreferrer" className={styles.assignedVoiceAgentLink} href={`${window.location.origin}/voiceagent/createvoiceagent?voice_agent_id=${assignedVoiceAgentData?.voice_agent?.voice_agent_id}`} target="_blank">{assignedVoiceAgentData?.voice_agent?.voice_agent_name}</a>
                                : "-"
                            }
                        </Grid>
                    </ConfigurationSection>
                </>
            }
        </Grid>
    )

    const agentActivityMessageTabData = (
            <Grid
                container
                direction="column"
                gap={2}
                onKeyDown={(e) => e.stopPropagation()}
            >
                {renderTabInfo("Notify users when agent is assigned, joined or leave the conversation")}

                <ConfigurationSection>
                    <Grid container className={styles.voiceCallingToggleRow}>
                        <Grid item className={styles.voiceCallingToggleLabel}>
                            Send Agent Activity Message
                        </Grid>

                        <Grid item className={globalStyles.displayFlex}>
                            <PrimaryIOSSwitch
                                className={styles.switch}
                                checked={flagSendAgentActicityMsg}
                                onChange={(e) => onChangeOfSendAgentActivityMsgSwitch(e.target.checked)}
                            />
                        </Grid>
                    </Grid>
                </ConfigurationSection>

                {flagSendAgentActicityMsg &&
                    <>
                        <Divider />
                        <AgentActivityMessages
                            agentAcitvityMsg={agentAcitvityMsg}
                            setAgentAcitvityMsg={setAgentAcitvityMsg}
                            channelName={'whatsapp'}
                            configureAgentActivityMsg={configureAgentActivityMsg}
                            flagDisableAgentOnUserInactivity={flagDisableAgentOnUserInactivity}
                            onCancel={onCancelOfAgentActivityMsg}
                            setShowPhoneNumberSettingsPopup={setShowPhoneNumberSettingsPopup}
                        />
                    </>
                }
            </Grid>
    )

    const userInactivityTabData = (
        <Grid
            container
            direction="column"
            gap={2}
            onKeyDown={(e) => e.stopPropagation()}
        >
            {renderTabInfo("Auto-remove agent if the user hasn't replied within a set time window")}

            <ConfigurationSection>
                <Grid container className={styles.voiceCallingToggleRow}>
                    <Grid item className={styles.voiceCallingToggleLabel}>
                        Remove Agent on User Inactivity
                    </Grid>

                    <Grid item className={globalStyles.displayFlex}>
                        <PrimaryIOSSwitch
                            className={styles.switch}
                            checked={flagDisableAgentOnUserInactivity}
                            onChange={(e) => onChangeOfRemoveAgentOnUserInactivitySwitch(e.target.checked)}
                        />
                    </Grid>
                </Grid>
            </ConfigurationSection>

            {flagDisableAgentOnUserInactivity &&
                <>
                    <Divider />
                    <AgentInactivityTime
                        timeOfInactivityInMs={timeOfInactivityInMs}
                        setTimeOfInactivityInMs={setTimeOfInactivityInMs}
                        configureAgentActivityMsg={configureAgentActivityMsg}
                        flagSendAgentActicityMsg={flagSendAgentActicityMsg}
                        onCancel={onCancelOfUserInactivity}
                        setShowPhoneNumberSettingsPopup={setShowPhoneNumberSettingsPopup}
                    />
                </>
            }
        </Grid>
    )

    const smbAgentAssignmentTabData = (
        <Grid container direction="column" gap={2}>
            {renderTabInfo(`When our agent replies from the SMB (WhatsApp Business App) to a conversation, takeover the conversation and assign it to "wa_smb_user".`)}

            <ConfigurationSection>
                <Grid container className={styles.voiceCallingToggleRow}>
                    <Grid item className={styles.voiceCallingToggleLabel}>
                        Assign Agent on SMB Message
                    </Grid>

                    <Grid item className={globalStyles.displayFlex}>
                        <PrimaryIOSSwitch
                            className={styles.switch}
                            checked={flagAgentAssignmentOnSmbMsg}
                            onChange={(e) => onChangeOfAssignAgentOnSmbMsg(e.target.checked)}
                        />
                    </Grid>
                </Grid>
            </ConfigurationSection>
        </Grid>
    )

    //  Tabs for Phone Number Settings Popup
    const phoneNumberTabs = [
        ...(shouldShowVoiceCallingSwitch() ? [
            {
                id: "voiceCalling",
                label: "Voice Calling",
                icon: <CallIcon />,
                component: voiceCallingTabData,
                footer: (
                    <GlobalButton
                        buttonText="Cancel"
                        className="borderedButtonStyle"
                        onClick={() => setShowPhoneNumberSettingsPopup(false)}
                        sx={{ minWidth: "100px" }}
                    />
                )
            }
        ] : []),
        {
            id: "agentActivityMessage",
            label: "Agent Activity",
            icon: <MessageIcon />,
            component: agentActivityMessageTabData,
            footer: (
                !flagSendAgentActicityMsg && (
                    <GlobalButton
                        buttonText="Cancel"
                        className="borderedButtonStyle"
                        onClick={() => setShowPhoneNumberSettingsPopup(false)}
                        sx={{ minWidth: "100px" }}
                    />
                )
            )
        },
        {
            id: "userInactivity",
            label: "User Inactivity",
            icon: <AccessTimeIcon />,
            component: userInactivityTabData,
            footer: (
                !flagDisableAgentOnUserInactivity && (
                    <GlobalButton
                        buttonText="Cancel"
                        className="borderedButtonStyle"
                        onClick={() => setShowPhoneNumberSettingsPopup(false)}
                        sx={{ minWidth: "100px" }}
                    />
                )
            )
        },
        ...(props?.details?.flag_smb_phone_number ? [
            {
                id: "smbAgentAssignment",
                label: "SMB Agent",
                icon: <SupportAgentIcon />,
                component: smbAgentAssignmentTabData,
                footer: (
                    <GlobalButton
                        buttonText="Cancel"
                        className="borderedButtonStyle"
                        onClick={() => setShowPhoneNumberSettingsPopup(false)}
                        sx={{ minWidth: "100px" }}
                    />
                )
            }
        ] : []),
    ];

    const handleClosePhoneNumberSettingsPopup = () => {
        setShowPhoneNumberSettingsPopup(false);
        onCancelOfAgentActivityMsg?.();
        onCancelOfUserInactivity?.();
    }

    return (
        <>
            <Grid item style={{ width: props.flagIntegration ? "" : "100%", opacity: props.disabled ? "0.5" : "1" }}>
                <Grid container className={globalStyles.flexColumn}>
                    {flagShowMetaIcon &&
                        <Grid item sx={{ background: currentlySelected ? tertiaryColor : whiteColor }} className={styles.header} xs={12}>
                            <Grid container className={globalStyles.spaceAlignmentCenter} >

                                <Grid item className={globalStyles.displayFlex}>
                                    <Grid container>
                                        <Grid className={globalStyles.displayFlex} item>
                                            <img
                                                alt="meta"
                                                className={styles.metaIconStyle}
                                                src={metaIcon}
                                            />
                                        </Grid>
                                        <Grid item className={styles.headerText}>{title}</Grid>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    {flagDelete ?
                                        <>
                                            {hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                <GlobalButton buttonText={"Delete"} className="deleteIntegrationButton" onClick={props.deleteChatbotIntegration} startIcon={<IconsColor iconName="DeleteIcon" fillColor={primaryColor} height="16" width="16" />} />
                                            }
                                        </>
                                        :
                                        <>
                                            <Grid container gap="10px">
                                                <Checkbox
                                                    checked={currentlySelected}
                                                    className={`${globalStyles.checkboxStyle} ${globalStyles.clickable}`}
                                                    checkedIcon={<IconsColor iconName="checkedIcon" width="22px" height="22px" />}
                                                    icon={<IconsColor iconName="uncheckedIcon" width="22px" height="22px" />}
                                                    onChange={(event) => {
                                                        if (props.addChatbotIntegration && details.phone_number_id && !currentlySelected) {
                                                            props.addChatbotIntegration(details.phone_number_id, details.integrated_channel_id || "")
                                                        }
                                                    }}
                                                />
                                                {showRemoveChatbotIntegration && currentlySelected && props.removeChatbotIntegration &&
                                                    <GlobalButton buttonText={"Remove"} className='boxShadowButtonStyle' onClick={() => {
                                                        if (props.removeChatbotIntegration && details.phone_number_id) {
                                                            props.removeChatbotIntegration(details.phone_number_id, details.integrated_channel_id)
                                                        }
                                                    }} />
                                                }
                                            </Grid>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>}
                    {flagShowMetaIcon && <Divider style={{ opacity: "0.8" }} />}

                    {flagShowMetaIcon &&
                        <Grid item mt={2}>
                            <Grid container className={`${globalStyles.flexRow} ${globalStyles.alignItemCenter}`} gap={2}>
                                {Object.entries(details).map(([key, value], ind: number) => {
                                    return (
                                        <>
                                            <Grid item xs={12} sm={5} md={4.5} lg={3.5} xl={2.5}>
                                                <Grid container gap={2} className={globalStyles.displayFlex} flexWrap={"nowrap"}>
                                                    <Grid item className={globalStyles.displayFlexStyle}>
                                                        {getDisplayIcon(key)}
                                                    </Grid>
                                                    <Grid item className={styles.objectKeyStyle}>
                                                        {getDisplayWabaFieldKeyName(key)}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} sm={7} md={6.5} lg={7} xl={9}>
                                                {key == "linked_chatbots" ? 
                                                    <Grid key={ind} className={`${styles.genericValueStyle} ${styles.infoValue}`} item>
                                                        {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot, index) => {
                                                            return <a key={ind + index} rel="noreferrer" href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot.chatbot_id}`} target="_blank">{chatbot.chatbot_name}</a>
                                                        }) : <span>None</span>
                                                        }
                                                    </Grid>
                                                    :
                                                    key == "display_phone_number" ? 
                                                    <Grid key={ind} sx={getValueStyle(key, value)} className={`${styles.genericValueStyle} ${styles.infoValue}`} item><span style={{ color: primaryColor, textDecoration: "underline", cursor: "pointer" }} onClick={() => { setShowQRCodePopUp(true); setPhoneNumberQR(value) }}>{String(value)}</span></Grid>
                                                    :
                                                    key == "catalog" ?
                                                    <>
                                                        <Grid container alignItems={'center'} flexWrap={"nowrap"} gap={1}>
                                                            <Grid key={ind} item sx={getValueStyle(key, value)} className={`${styles.genericValueStyle} ${styles.infoValue}`}>{String(value)}</Grid>
                                                            {process.env.REACT_APP_META_CATALOG_API_ENABLED == "true" && 
                                                                <GlobalTooltip
                                                                    title="Sync Catalog"
                                                                    placement='top'
                                                                    arrow
                                                                >
                                                                    <Grid item className={`${globalStyles.clickable}`} onClick={() => syncCatalogApi()}>
                                                                        <SyncIcon className={globalStyles.primaryColor} />
                                                                    </Grid>
                                                                </GlobalTooltip>
                                                            }
                                                        </Grid>
                                                    </>
                                                    :
                                                    <Grid key={ind} item sx={getValueStyle(key, value)} className={`${styles.genericValueStyle} ${styles.infoValue}`}>{String(value)}</Grid>
                                                }
                                            </Grid>
                                        </>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    }

                    {!flagShowMetaIcon &&
                        <Grid item>
                            <Grid container className={`${styles.facebookIntegrationCard} ${globalStyles.flexColumn}`}>
                                
                                <Grid item className={`${styles.integrationWabaID} ${styles.facebookIntegrationCardHeader}`}>
                                    <span className={styles.pageIDStyle}>
                                        ID: {props.details.phone_number_id}
                                    </span>

                                    {flagShowPhoneNumberSettings &&
                                        <span 
                                            className={`${globalStyles.displayFlex} ${styles.facebookIntegrationCardHeaderSettingsIcon}`}
                                            onClick={() => { setShowPhoneNumberSettingsPopup(true) }}
                                        >
                                            <IconsColor 
                                                iconName="integrationSettings"
                                                fillColor="#8E8E8E"
                                            />
                                        </span>
                                    }
                                </Grid>

                                <Grid item>
                                    <Grid container className={globalStyles.contentEnd} >
                                        <Grid item className={`${styles.wpintegrationIcon} ${styles.wpintegrationBackColor} `} >
                                            <img alt="" src={whatsappIcon} height={"32"} width={"32"} />
                                        </Grid>
                                        {!props.flagIntegration &&
                                            <Grid item className={styles.connectionStyle} sx={{ color: details.linked_chatbots && details.linked_chatbots.length > 0 ? "#32BB46" : "#BB3232" }}>
                                                <span className={styles.wpconnectionTextStyle}>{details.linked_chatbots && details.linked_chatbots.length > 0 ? "Connected" : "Not Connected"}</span>
                                            </Grid>
                                        }
                                        {props.flagIntegration &&
                                            <Grid item className={styles.connectionStyle} sx={{ color: currentlySelected ? "#32BB46" : "#BB3232" }}>
                                                <span className={styles.wpconnectionTextStyle}>{currentlySelected ? "Connected" : "Not Connected"}</span>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.integrationPageName}>
                                    <Grid container className={`${globalStyles.spaceAlignmentCenter} ${globalStyles.flexRow} ${globalStyles.gapOne}`}>
                                        <Grid item>
                                            <span className={styles.phoneNumberDefaultStyle}>{props.details.display_phone_number}</span>
                                        </Grid>
                                        <Grid item>
                                            {!props.disabled && <img alt='' src={QRimage} height={"26"} width={"26"} className={globalStyles.clickable} onClick={() => { setShowQRCodePopUp(true); setPhoneNumberQR(props.details.display_phone_number ? props.details.display_phone_number : "") }} />}
                                            {props.disabled && <img alt='' src={QRimage} height={"26"} width={"26"} className={globalStyles.clickable} />}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.businessName}>
                                    <Grid container className={globalStyles.flexColumn}>
                                        <Grid item className={styles.pageCategoryStyle}>
                                            <span>Display Name</span>
                                        </Grid>
                                        <Grid item className={styles.chatbotNameStyle}>
                                            <span>{props.details.business_name}</span>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item className={styles.integrationPageCategory}>
                                    <Grid container className={globalStyles.spaceAlignmentCenter}>
                                        <Grid item>
                                            <Grid container className={globalStyles.flexColumn}>
                                                <Grid item className={styles.pageCategoryStyle}>
                                                    <span>Quality rating</span>
                                                </Grid>
                                                <Grid item className={styles.qualityRatingTextStyle} sx={{ color: getFontColor(props.details.quality_rating ? props.details.quality_rating : "") }}>
                                                    <span>{props.details.quality_rating}</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {!props.flagShowLinkedChatbot && showRemoveChatbotIntegration && props.flagIntegration &&
                                            currentlySelected && props.removeChatbotIntegration &&
                                            <Grid item>
                                                <GlobalButton buttonText={"Un-deploy"} className='delinkChatbotButtonStyle' onClick={() => {
                                                    if (props.removeChatbotIntegration && details.phone_number_id) {
                                                        props.removeChatbotIntegration(details.phone_number_id, details.integrated_channel_id || "")
                                                    }
                                                }} />
                                            </Grid>
                                        }
                                        {!props.flagShowLinkedChatbot && !showRemoveChatbotIntegration && props.flagIntegration && props.removeChatbotIntegration && props.addChatbotIntegration &&
                                            <Grid item>
                                                <GlobalButton buttonText={"Deploy"} className='linkChatbotButtonStyle' onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                                    if (props.addChatbotIntegration && details.phone_number_id && !currentlySelected) {
                                                        props.addChatbotIntegration(details.phone_number_id, details.integrated_channel_id || "", event)
                                                    }
                                                }} disabled={currentlySelected} />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>


                                {props.flagShowLinkedChatbot && 
                                    <>
                                        <Grid item className={styles.integrationPageCategory}>
                                            <Grid container className={`${globalStyles.flexRow} ${globalStyles.gapOne}`} justifyContent={props.flagShowLinkedChatbot ? "space-between" : "end"}>
                                                <Grid item>
                                                    <Grid container className={globalStyles.flexColumn}>
                                                        <Grid item className={styles.pageCategoryStyle}>
                                                            <span>Linked Chatbot</span>
                                                        </Grid>
                                                        {!props.flagIntegration && 
                                                            <Grid item className={styles.chatbotNameStyle}>
                                                                {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot, ind) => {
                                                                    return (
                                                                        <Grid container gap={"5px"} className={globalStyles.alignItemCenter}>
                                                                            <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot.chatbot_id ?? chatbot.ai_chatbot_id}`} target="_blank">{chatbot.chatbot_name}</a>
                                                                            <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>(Main Chatbot)</Typography>
                                                                        </Grid>
                                                                    )
                                                                }) : <span className={globalStyles.secondaryFontWeight} >None</span>}
                                                            </Grid> 
                                                        }
                                                        {props.flagIntegration &&
                                                            <Grid item className={styles.chatbotNameStyle}>
                                                                {details.linked_chatbots && details.linked_chatbots.length > 0 ? details.linked_chatbots.map((chatbot, ind) => {
                                                                    return props.disabled ? <span key={ind} className={styles.chatbotNameLink}>{chatbotList?.find((list) => Number(list.chatbot_id) == (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id))?.chatbot_name}</span> : <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/chatbot/viewChatbot?chatbot_id=${chatbot.chatbot_id}`} target="_blank">{chatbotList?.find((list) => Number(list.chatbot_id) == (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id))?.chatbot_name}</a>
                                                                }) : <span className={globalStyles.secondaryFontWeight}>None</span>}
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                {showRemoveChatbotIntegration && props.flagIntegration &&
                                                    currentlySelected && props.removeChatbotIntegration &&
                                                    <Grid item>
                                                        <GlobalButton buttonText={"Un-deploy"} className='delinkChatbotButtonStyle' onClick={() => {
                                                            if (props.removeChatbotIntegration && details.phone_number_id) {
                                                                props.removeChatbotIntegration(details.phone_number_id, details.integrated_channel_id || "")
                                                            }
                                                        }} />
                                                    </Grid>
                                                }
                                                {!showRemoveChatbotIntegration && props.flagIntegration && props.removeChatbotIntegration && props.addChatbotIntegration &&
                                                    <Grid item>
                                                        <GlobalButton buttonText={"Deploy"} className='linkChatbotButtonStyle' onClick={(event) => {
                                                            if (props.addChatbotIntegration && details.phone_number_id && !currentlySelected) {
                                                                props.addChatbotIntegration(details.phone_number_id, details.integrated_channel_id || "", event)
                                                            }
                                                        }} disabled={currentlySelected} />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>  

                                        {props?.details?.linked_workflows && 
                                            <Grid item className={styles.integrationPageCategory}>
                                                <Grid container className={`${globalStyles.flexRow} ${globalStyles.gapOne}`} justifyContent={props.flagShowLinkedChatbot ? "space-between" : "end"}>
                                                    <Grid item>
                                                        <Grid container className={globalStyles.flexColumn}>
                                                            <Grid item className={styles.pageCategoryStyle}>
                                                                <span>Linked Rule-Based Chatbot</span>
                                                            </Grid>
                                                            {!props.flagIntegration && 
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_workflows && details.linked_workflows.length > 0 ? details.linked_workflows.map((chatbot, ind) => {
                                                                        return ( 
                                                                            <>
                                                                                <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/workflow/staticWorkflowDetails?workflow_id=${chatbot.chatbot_id}`} target="_blank">{chatbot.chatbot_name}</a> 
                                                                                {ind < (props?.details?.linked_workflows?.length || 0) - 1 && ", "}
                                                                            </>

                                                                        )
                                                                    }) : <span className={globalStyles.secondaryFontWeight} >None</span>}
                                                                </Grid> 
                                                            } 
                                                            {props.flagIntegration &&
                                                                <Grid item className={styles.chatbotNameStyle}>
                                                                    {details.linked_workflows && details.linked_workflows.length > 0 ? details.linked_workflows.map((chatbot, ind) => {
                                                                        return <> 
                                                                                {props.disabled ? 
                                                                                    <span key={ind} className={styles.chatbotNameLink}>{chatbot?.chatbot_name}</span> 
                                                                                    : 
                                                                                    <a key={ind} rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/workflow/staticWorkflowDetails?workflow_id=${chatbot.chatbot_id}`} target="_blank">
                                                                                        {chatbot?.chatbot_name}
                                                                                    </a>
                                                                                }  
                                                                                {ind < (props?.details?.linked_workflows?.length || 0) - 1 && ", "}
                                                                            </>
                                                                    }) : <span className={globalStyles.secondaryFontWeight}>None</span>}
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </>
                                }

                                {shouldShowAssignedVoiceAgent() &&
                                    <Grid item  className={`${styles.integrationPageCategory}`}>
                                        <Grid container direction={"column"}>
                                            <Grid item className={styles.pageCategoryStyle}>{`Assigned Voice Agent`}</Grid>
                                            <Grid item className={styles.chatbotNameStyle}>
                                                {assignedVoiceAgentData?.is_assigned ? <a rel="noreferrer" className={styles.chatbotNameLink} href={`${window.location.origin}/voiceagent/createvoiceagent?voice_agent_id=${assignedVoiceAgentData?.voice_agent?.voice_agent_id}`} target="_blank">{assignedVoiceAgentData?.voice_agent?.voice_agent_name}</a> : "-"}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {props.flagShowCustomRecipient &&
                                    <Grid item className={`${styles.integrationPageCategory}`}>
                                        <Grid container gap={"5px"} className={globalStyles.alignItemCenter}>
                                            <Grid item>
                                                <Typography className={styles.assignCustomRecipientTypography} onClick={() => navigate(`/channels/viewintegration/whatsapp/phonenumbers/customRecipient?id=${id}&phonenumberId=${props.details.phone_number_id}`)}>
                                                    Assign Custom Recipient
                                                </Typography>
                                            </Grid>
                                            <Grid item className={globalStyles.displayFlex}>
                                                <GlobalTooltip
                                                    placement='top'
                                                    arrow
                                                    title={getTitleOfCustomRecipientTooltip()}
                                                    children={<InfoOutlinedIcon className={styles.infoTooltipIcon} />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>

            {showQRCodePopUp &&
                <GlobalPopUp
                    open={showQRCodePopUp}
                    onClose={() => { setShowQRCodePopUp(false) }}
                    flagShowCloseIcon={true}
                    handleClose={() => { setShowQRCodePopUp(false) }}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <QrCodePopup
                        phoneNumberQR={phoneNumberQR}
                    />
                </GlobalPopUp>
            }

            {/* Phone Number Settings Popup */}
            {showPhoneNumberSettingsPopup &&
                <ConfigurationPopup
                    open={showPhoneNumberSettingsPopup}
                    onClose={handleClosePhoneNumberSettingsPopup}
                    title="Phone Number Settings"
                    header={
                        <ConfigurationHeader
                            title={props?.details?.business_name ?? "Business Display Name"}
                            subTitle={props?.details?.display_phone_number ?? "-"}
                            subTitleLabel="Phone Number"
                            icon={whatsappIcon}
                        />
                    }
                    tabs={phoneNumberTabs}
                    maxWidth="1000px"
                />
            }
        </>
    )
}
